module.exports = __webpack_public_path__ + "img/cdkf2.8183088a.jpg";